import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bankCard3",
  "use": "icon-bankCard3-usage",
  "viewBox": "0 0 24 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 16\" id=\"icon-bankCard3\">\r\n  <g fill=\"none\" fill-rule=\"evenodd\">\r\n    <rect fill=\"#252525\" height=\"16\" rx=\"2\" width=\"24\" />\r\n    <circle cx=\"9\" cy=\"8\" fill=\"#eb001b\" r=\"5\" />\r\n    <circle cx=\"15\" cy=\"8\" fill=\"#f79e1b\" r=\"5\" />\r\n    <path d=\"m12 3.99963381c1.2144467.91220633 2 2.36454836 2 4.00036619s-.7855533 3.0881599-2 4.0003662c-1.2144467-.9122063-2-2.36454837-2-4.0003662s.7855533-3.08815986 2-4.00036619z\" fill=\"#ff5f00\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bankCard3.svg
// module id = bN0V
// module chunks = 63